import { Box, IconButton } from "@mui/material";

import { AccountBox, Login, Logout, Webhook } from "@mui/icons-material";

import { useEffect, useState } from "react";

import { useIdentity } from "./IdentityProvider";

import { useTrueBizApi } from "../api";

export default function AccountMeta() {
  const [webhookAuthUrl, setWebhookAuthUrl] = useState<
    string | null | undefined
  >(undefined);
  const [loadingWebhookDashboard, setLoadingWebhookDashboard] =
    useState<boolean>(false);
  const identity = useIdentity();
  const api = useTrueBizApi();

  const getWebhookDashboardUrl = async (
    webhookAuthUrl: string | null | undefined
  ) => {
    if (webhookAuthUrl === null) {
      console.log("This account does not have webhooks enabled.");
      return;
    }
    if (webhookAuthUrl === undefined) {
      return;
    }
    try {
      const webhookAuth = await api.webhookLookup(webhookAuthUrl);
      return webhookAuth?.dashboard_url;
    } catch {
      // pass
    }
  };

  const handleWebhookAuthRedirect = () => {
    setLoadingWebhookDashboard(true);
    getWebhookDashboardUrl(webhookAuthUrl).then((webhookDashboardUrl) => {
      if (webhookDashboardUrl === null) {
        alert("This account does not have webhooks enabled.");
        return;
      }
      if (webhookDashboardUrl === undefined) {
        alert(
          "Cannot retrieve the dashboard redirect URL. " +
            "This is most likely caused by a network error that may resolve itself. Please try again."
        );
        setLoadingWebhookDashboard(false);
        return;
      }
      window.open(webhookDashboardUrl, "svix_dashboard");
      setLoadingWebhookDashboard(false);
    });
  };

  useEffect(() => {
    const getAccountInfo = async () => {
      try {
        const account = await api.accountLookup();
        setWebhookAuthUrl(account.webhook_auth_url);
      } catch {
        // pass
      }
    };

    getAccountInfo();
  });

  const notAuthenticated = (
    <IconButton
      onClick={() => identity.login()}
      title="Log in"
      sx={{ color: "white" }}
    >
      <Login />
    </IconButton>
  );

  const authenticated = (
    <>
      {!!identity.settings && (
        <IconButton
          onClick={() => identity.settings?.()}
          title="Account settings"
          sx={{ color: "white" }}
        >
          <AccountBox />
        </IconButton>
      )}
      <IconButton
        onClick={() => identity.logout()}
        title="Log out"
        sx={{ color: "white" }}
      >
        <Logout />
      </IconButton>
      <IconButton
        disabled={!webhookAuthUrl || loadingWebhookDashboard}
        onClick={() => handleWebhookAuthRedirect()}
        title="Webhook Dashboard"
        sx={{ color: "white" }}
      >
        <Webhook />
      </IconButton>
    </>
  );

  return (
    <Box
      display="flex"
      alignItems="baseline"
      flex={1}
      justifyContent="end"
      paddingRight="0.75em"
    >
      {identity.isAuthenticated ? authenticated : notAuthenticated}
    </Box>
  );
}
